import React, { useState, useEffect } from "react";
import {
  Drawer,
  Input,
  Button,
  message,
  Row,
  Col,
  Tooltip,
  Typography,
  Table,
  Tag,
} from "antd";
import { useMutation, useQuery } from "@apollo/client";
import { ASSIGN_PRODUCTS, GET_PRODUCTS } from "./requests";
import ProductList from "../../../components/productsList";
import { productTypes } from "../../../types";
import { Location } from "../../../types/location";

const { Text } = Typography;

interface AssignProductsProps {
  showModal: boolean;
  setShowModal: (visible: boolean) => void;
  refetch: () => void;
  location: Location | null;
}

const AssignProducts: React.FC<AssignProductsProps> = ({ showModal, setShowModal, refetch, location }) => {
  const [loading, setLoading] = useState(false)
  const [searchTitle, setSearchTitle] = useState("");
  const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
  const [pageConfig, setPageConfig] = useState({ page: 1,
    pageSize: 10 });

  const [assignProducts] = useMutation(ASSIGN_PRODUCTS);

  const { data, loading: loadingProducts } = useQuery(GET_PRODUCTS, { variables: { params: pageConfig,
    name:searchTitle } });
  const products = data?.products.results || [];

  useEffect(() => {
    if (location) {
      setSelectedProducts(location?.products?.map((p) => p.id) ?? []);
    }
  }, [location]);

  console.log({ selectedProducts })

  const handleSubmit = async () => {
    setLoading(true);
    try {

      const payload = {
        variables: {
          location: location?.id,
          products: selectedProducts,
        },
      }

      await assignProducts(payload);
      await refetch();

      message.success("Productos asignados exitosamente");
      onClose();
    } catch (error) {
      console.log(error);
      message.error("Error al asignar productos");
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    setShowModal(false);
    setSearchTitle("");
    setSelectedProducts([]);
  }

  const handleSelect = (record: any) => {
    const keys = [...selectedProducts];
    if (keys.includes(record.id)) {
      setSelectedProducts(keys.filter((key) => key !== record.id));
    } else {
      setSelectedProducts([...keys, record.id]);
    }
  };

  const rowSelection = {
    selectedRowKeys: selectedProducts,
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedProducts(selectedRowKeys as string[]);
    },
    preserveSelectedRowKeys: true,
  };

  const columns = [
    {
      title: "Nombre",
      key: "name",
      render: (row: typeof productTypes.product) => {
        return <Text strong>{row.name}</Text>;
      },
    },
    {
      title: "Descripción",
      key: "description",
      render: (row: typeof productTypes.product) => {
        return <Text strong>{row.description}</Text>;
      },
    },
    {
      title: 'Variantes',
      key: 'variants',
      dataIndex: 'variants',
      render: (variants: typeof productTypes.product['variants']) => {

        const lineItems = variants?.map((p) => ({
          product: {
            _id: p.id,
            img: p.img,
            title: p.title,
            description: p.description,
            product: {
              name: p.product.name,
              description: p.product.description,
            },
          },
        })) ?? [];

        if(lineItems.length > 0){
          return <ProductList lineItems={lineItems} />;
        } else {
          return <Tag color="yellow">Sin Productos</Tag>
        }
      },
    },
  ];

  return (
    <Drawer
      title="Asignar Productos"
      open={showModal}
      onClose={onClose}
      width={"60%"}
    >

      <Row>
        <Col span={18}>
          <Tooltip title="Buscar Producto por Nombre">
            <Input
              placeholder="Buscar Producto por Nombre"
              value={searchTitle}
              onChange={(e) => setSearchTitle(e.target.value)}
              allowClear
            />
          </Tooltip>
        </Col>
        <Col span={6}>
          <Text style={{ marginLeft:10,
            fontSize:"15px" }} strong>Productos Seleccionados: {selectedProducts.length}</Text>
        </Col>
      </Row>
      <div style={{ marginTop: 10 }}>
        <Table
          dataSource={products}
          rowKey="id"
          loading={loadingProducts}
          pagination={{
            current: Number(pageConfig.page),
            defaultCurrent: pageConfig.page,
            pageSize: Number(pageConfig.pageSize),
            defaultPageSize: pageConfig.pageSize,
            total: data?.products?.info?.count,
            showTotal: (total) => (
              <Text disabled>{`${total} resultados`}</Text>
            ),
            onChange: (page, pageSize) => {
              setPageConfig({
                page,
                pageSize,
              });
            },
            showSizeChanger: true,
          }}
          rowSelection={rowSelection}
          onRow={(record) => ({
            onClick: () => handleSelect(record),
          })}
          columns={columns}
        />
        <Button size="large" loading={loading} type="primary" onClick={handleSubmit} style={{ marginTop: 20 }}>
            Guardar
        </Button>
      </div>
    </Drawer>
  );
};

export default AssignProducts;
